module.exports = __webpack_public_path__ + "img/art2.1c692d4a.png";